<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <factor-tree-query ref="factor-tree" :factor-tree="factorTree" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch :default-unit-prop.sync="unitProp" @change="onUnitPropChange" />

        <dimension-type :default-dimension-type.sync="dimension" @change="onDimensionChanged" />
      </template>

      <x-y-chart
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
        :chart-type="chartType"
        :stack-type="stackType"
        :download-name="downloadName"
        selected-change-with-data-changed
        chart-min-height="400px"
        chart-height="auto"
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../components/Data/Query/FactorTreeQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DimensionType from '../../../../components/Data/DimensionType'
import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'DataDisplayVOCsSingleSpecies',
  routeInfo: {
    label: 'VOCs单物种',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {DataWrapper, CompletedQuery, FactorTreeQuery, SiteQuery, DataTimeQuery, LayoutContent, UnitSwitch, DimensionType, XYChart},
  data: () => ({
    query: {
      isFuse: false,
      isMultipleIntegral: true
    },
    chartType: 'line',
    stackType: 0
  }),
  computed: {
    isSetAllFactorIds: () => false,
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true)
    ],
    downloadName: () => 'VOCs单物种',
    factorTree () {
      let {_factorTree} = this

      if (_factorTree.length === 0) {
        return []
      }

      let factorTree = JSON.parse(JSON.stringify(_factorTree))
      return factorTree.length > 1 ? factorTree : factorTree[0].children
    }
  },
  methods: {
    // onAuditCompletedChanged () {
    //   let {query} = this

    //   if (query.isAuditCompleted === 'isFuse') {
    //     query.isFuse = true
    //     delete query.isAuditCompleted
    //   } else {
    //     query.isFuse = false
    //   }
    //   if (query.isAuditCompleted === true) {
    //     query.isGetInvalidData = false
    //   } else {
    //     query.isGetInvalidData = true
    //   }

    //   this.afterSetSiteIds()
    // },
    getSeriesParam (dimension, dimensionIds) {
      let param = {
        type: 'line',
        showSymbol: false
      }

      return param
    },
    onDimensionChanged () {
      this.formatData()
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/02VOCs-Photochemical/02Single-Species/index.vue